module.exports = __webpack_public_path__ + "media/src/assets/lake_like_a_local-ec0630db4053d03c3d94743c384c2c3d.png";